//#region IMPORT
import React, { useEffect, useRef } from 'react';
import { BusinessGridCommon } from '../../../../Components/BusinessGridCommon';
import GridFunctions from '../../../../Services/agGrid/ag-Grid-functions';
import { useSelector } from 'react-redux';
import { getColumnDefs1 } from './SAT_BASIC_03_ColumnDefs';
function SAT_BASIC_03(props) {
  const defaultGridRef = useRef(); // 교육현황
  const gridRef1 = props.gridRef1 || defaultGridRef;
  const searchInfo = useSelector((state) => state.SearchInfo);
  const columnDefs1 = getColumnDefs1(props);

  //#region AuthButton 이벤트
  useEffect(() => {
    if (props.filterClick3) {
      if (!props.validateSelection()) {
        props.setFilterClick3(false);
        return;
      }

      gridRef1.current.api.setQuickFilter(searchInfo.searchText);
      props.setFilterClick3(false);
    }
    if (props.searchClick3) {
      props.ResetLogic1();
      if (!props.validateSelection()) {
        props.setSearchClick3(false);
        return;
      }

      props.SearchLogic1(searchInfo.custCd, searchInfo.searchYear);
      props.setSearchClick3(false);
    }
    if (props.addClick3) {
      if (!props.validateSelection()) {
        props.setAddClick3(false);
        return;
      }

      GridFunctions.addClick(gridRef1);
      props.setAddClick3(false);
    }
    if (props.saveClick3) {
      if (!props.validateSelection()) {
        props.setSaveClick3(false);
        return;
      }

      props.SaveLogic1();
      props.setSaveClick3(false);
    }
    if (props.deleteClick3) {
      if (!props.validateSelection()) {
        props.setDeleteClick3(false);
        return;
      }

      props.DeleteLogic1();
      props.setDeleteClick3(false);
    }
    if (props.printClick3) {
      if (!props.validateSelection()) {
        props.setPrintClick3(false);
        return;
      }

      props.PrintLogic1();
      props.setPrintClick3(false);
    }
  }, [
    props.filterClick3,
    props.searchClick3,
    props.addClick3,
    props.saveClick3,
    props.deleteClick3,
    props.printClick3,
  ]);

  //#endregion
  return (
    <React.Fragment>
      <BusinessGridCommon
        gridRef={gridRef1}
        columnDefs={columnDefs1}
        rowData={props.rowData1}
        setChangedRowData={props.setChangedRowData1}
        setSelectedRowData={props.setSelectedRowData1}
        flex={1}
        title1="연간교육 계획표"
        gridId={props.gridId1}
        getRowId={(params) => {
          return params.data.no;
        }}
        deleteYn1="Y"
        addYn1="Y"
        fileUploadYn1="Y"
        fileDownloadYn1="Y"
        fileUploadClick1={() => {
          if (!props.validateSelection()) return;
          props.fileInputRef?.current?.click();
        }}
        fileDownloadClick1={() => {
          if (!props.validateSelection()) return;
          props.ExcelDownload1?.();
        }}
        addClick1={() => {
          if (!props.validateSelection()) return;

          GridFunctions.addClick(gridRef1);
        }}
        deleteClick1={(e) => {
          if (!props.validateSelection()) return;

          const newRowExists = props.selectedRowData1.some(
            (row) => row.newYn === 'Y'
          );

          if (!newRowExists) {
            props.MarkedForDeletion1(props.selectedRowData1);
          } else {
            props.NewYnErrorMsg?.();
          }
        }}
        refreshClick1={() => {
          if (!props.validateSelection()) return;

          props.SearchLogic1(searchInfo.custCd, searchInfo.searchYear);
        }}
      />
      {/* 엑셀 업로드용 숨김 파일 input */}
      <input
        type="file"
        ref={props.fileInputRef}
        style={{ display: 'none' }}
        accept=".xlsx,.xls"
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) {
            props.ExcelUpload1?.(file);
            e.target.value = '';
          }
        }}
      />
    </React.Fragment>
  );
}

export default SAT_BASIC_03;
